/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./originators.vue?vue&type=template&id=0157984e"
import script from "./originators.vue?vue&type=script&lang=js"
export * from "./originators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports